/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.thinkprocess.CloseReason
*/
export var CloseReason;
(function (CloseReason) {
    CloseReason["DONE"] = "DONE";
    CloseReason["INCOMPLETE"] = "INCOMPLETE";
    CloseReason["STOPPED"] = "STOPPED";
    CloseReason["FORCE"] = "FORCE";
    CloseReason["STALE"] = "STALE";
    CloseReason["ARCHIVED"] = "ARCHIVED";
    CloseReason["USER_DELETE"] = "USER_DELETE";
    CloseReason["ABANDONED"] = "ABANDONED";
    CloseReason["AUTO_CLOSE"] = "AUTO_CLOSE";
})(CloseReason || (CloseReason = {}));
//# sourceMappingURL=CloseReason.js.map